module.exports = __webpack_public_path__ + "static/tusas-motor-2-7922825cf35fd00d2dcfd0c97a47975c.png";